var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBiayaLebihTerjangkau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1205 14.4808C41.2301 12.0721 37.5315 10.625 33.5 10.625C24.2488 10.625 16.75 18.2357 16.75 27.625C16.75 37.0143 24.2488 44.625 33.5 44.625C42.7512 44.625 50.25 37.0143 50.25 27.625C50.25 25.6466 49.9003 23.7554 49.2879 21.9895C46.5901 20.434 44.644 17.7002 44.1205 14.4808V14.4808Z",
    fill: "#FAB400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 44.625H14.6562V59.5H8.375V44.625Z",
    fill: "#64C8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 44.625H10.4688V59.5H8.375V44.625Z",
    fill: "#46AAD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2608 51.1498L38.0759 53.0761C37.8173 53.1091 37.5566 53.125 37.296 53.125H31.4062C30.2495 53.125 29.3125 52.1741 29.3125 51L38.0979 49.2171C39.0767 49.0184 39.7812 48.1461 39.7812 47.1325V46.75H14.6562V55.25L31.3686 59.0187C32.7661 59.3343 34.2203 59.2801 35.5917 58.8625L53.6911 53.3513C54.1339 53.2174 54.4375 52.8041 54.4375 52.3345V52.2038C54.4375 51.5642 53.8858 51.0701 53.2608 51.1498V51.1498Z",
    fill: "#F0C8A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 27.625C20.9375 18.9571 27.3339 11.8192 35.5938 10.7716C34.906 10.6845 34.2108 10.625 33.5 10.625C24.2488 10.625 16.75 18.2357 16.75 27.625C16.75 37.0143 24.2488 44.625 33.5 44.625C34.2108 44.625 34.906 44.5655 35.5938 44.4784C27.3339 43.4307 20.9375 36.2929 20.9375 27.625Z",
    fill: "#DC9600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 38.25C39.2817 38.25 43.9688 33.493 43.9688 27.625C43.9688 21.757 39.2817 17 33.5 17C27.7183 17 23.0312 21.757 23.0312 27.625C23.0312 33.493 27.7183 38.25 33.5 38.25Z",
    fill: "#BE7800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.85 23.9817V21.5539H34.617V19.125H32.383V21.5539H30.15V28.8394H34.617V31.2683H30.15V33.6961H32.383V36.125H34.617V33.6961H36.85V26.4106H32.383V23.9817H36.85Z",
    fill: "#FAB400"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4375 21.25C59.0629 21.25 62.8125 17.4444 62.8125 12.75C62.8125 8.05558 59.0629 4.25 54.4375 4.25C49.8121 4.25 46.0625 8.05558 46.0625 12.75C46.0625 17.4444 49.8121 21.25 54.4375 21.25Z",
    fill: "#3CC8B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1562 12.75C48.1562 8.41606 51.3545 4.84712 55.4844 4.32331C55.141 4.27975 54.7924 4.25 54.4375 4.25C49.8124 4.25 46.0625 8.05587 46.0625 12.75C46.0625 17.4441 49.8124 21.25 54.4375 21.25C54.7924 21.25 55.141 21.2202 55.4844 21.1767C51.3545 20.6529 48.1562 17.0839 48.1562 12.75Z",
    fill: "#1EAA96"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6719 10.625L53.3906 17L49.2031 12.75L51.2969 10.625L53.3906 12.75L57.5781 8.5L59.6719 10.625Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBiayaLebihTerjangkau);
export default __webpack_public_path__ + "static/media/ic-biaya-lebih-terjangkau.f0e81b5e3042ffc9496d457beaae8151.svg";
export { ForwardRef as ReactComponent };